export default __webpack_public_path__ + "static/media/icon_schedule_minus.cc933551.svg";